import React from 'react'
import { motion } from 'framer-motion'
import { MoonIcon, SunIcon } from 'lucide-react'
import { useTheme } from '../context/ThemeContext'
import Button from './Button'

interface ThemeToggleButtonProps {
  className?: string
  size?: 'small' | 'medium' | 'large'
  variant?: 'icon-only' | 'with-text'
}

const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({
  className = '',
  size = 'small',
  variant = 'with-text'
}) => {
  const { theme, toggleTheme } = useTheme()
  
  // For icon-only variant
  if (variant === 'icon-only') {
    return (
      <motion.button
        onClick={toggleTheme}
        className={`rounded-full p-2 transition-colors ${
          theme === 'dark'
            ? 'bg-white/10 hover:bg-white/20 text-white' 
            : 'bg-blue-100/50 hover:bg-blue-100 text-blue-800'
        } ${className}`}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        {theme === 'dark' ? (
          <SunIcon className="w-5 h-5" />
        ) : (
          <MoonIcon className="w-5 h-5" />
        )}
      </motion.button>
    )
  }
  
  // Default with text button
  return (
    <Button
      variant={theme === 'dark' ? 'outline' : 'secondary'}
      onClick={toggleTheme}
      icon={theme === 'dark' ? <SunIcon className="w-4 h-4" /> : <MoonIcon className="w-4 h-4" />}
      size={size}
      className={className}
    >
      {theme === 'dark' ? 'الوضع الفاتح' : 'الوضع الداكن'}
    </Button>
  )
}

export default ThemeToggleButton 